<template lang="pug">
  v-alert.mt-4(v-if="showBanner" type="info" text)
    v-row.px-1(align='center' dense)
      v-col.pa-0.grow
        div.h6.info500--text.pb-2   Important Notice
        div.caption.
          Due to tighter regulation by Bank Negara Malaysia (BNM), Yezza Pay is required to upgrade its payment policy.<br/><br/>

          To continue using online payment features in Yezza, you are required to choose either one of the  options below by  <strong>21st January 2022</strong>:<br/><br/>
        div.body-2.black--text <strong>(1) SecurePay - Low FPX rates</strong><br/><br/>
        div.caption.
          <strong>FPX Rates</strong> : <br/>RM 1.50 for Free/Personal Plan <br/>RM 1.00 for Start/Business/Growth/Intelligence Plan<br/>
          <strong>Settlement</strong> : 3 working days<br/>
          <strong>Account Activation</strong> : within 24 hours<br/>
          <strong>Requirement</strong> : Registered Business (SSM Document)<br/>

    v-row.mt-2.mb-2
      v-col.ma-0.pa-0.pt-2.pr-4.mx-4
        v-btn.elevation-0(block small color="info" @click="clickNewSecurePayButton") Activate SecurePay
        div.body-2.mt-4.black--text <strong> (2) Stripe - FPX, Credit/Debit Card, GrabPay</strong><br/><br/>
        div.caption.
          <strong>FPX Rates</strong> : RM 1.50 + 0.25%<br/>
          <strong>Settlement</strong> : 3 working days<br/>
          <strong>Account activation</strong> : Instant<br/>
          <strong>Requirement</strong> : Individuals (NRIC) or Registered Business (SSM Document)<br/><br/>

          <strong>Additional Payment Method</strong>:<br/>
          - Credit/Debit Card<br/>
          - GrabPay



    v-row.mt-2.mb-2
      v-col.ma-0.pa-0.pt-2.pr-4.mx-4
        v-btn.elevation-0(block small color="info" @click="clickNewYezzaPayButton") Activate Stripe


</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'PaymentSettingsYezzaPayMigrateBanner',
  props: ['company'],
  data: () => ({
    showBanner: false
  }),
  mounted () {
    if (this.company.default_payment_gateway !== 'yezzapay') {
      return
    }
    this.$axios.get(`/yezzapays/?company=${this.company.id}`).then((response) => {
      if (response.data.results.length > 0) {
        let settings = response.data.results[0]
        if (settings.active_fpx_provider === 'yezza_maybank') {
          this.showBanner = true
        }
      }
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    clickNewYezzaPayButton() {
      this.$axios.post(`https://hooks.zapier.com/hooks/catch/1847976/b9fcov5/?event=activatestripe&companyid=${this.company.id}`)
      this.$store.commit('ui/setYezzapayMigrateModal', true)
    },
    clickNewSecurePayButton() {
      this.$axios.post(`https://hooks.zapier.com/hooks/catch/1847976/b9fcov5/?event=activatesecurepay&companyid=${this.company.id}`)
      this.$store.commit('ui/setSecurepayMigrateModal', true)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
